"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationServiceImpl = void 0;
const NotificationServiceImplBase_1 = require("./NotificationServiceImplBase");
class NotificationServiceImpl extends NotificationServiceImplBase_1.NotificationServiceImplBase {
    get serviceName() {
        return "notification-service" /* ServiceNames.Notification */;
    }
}
exports.NotificationServiceImpl = NotificationServiceImpl;
//# sourceMappingURL=NotificationServiceImpl.js.map